import { Controller } from '@hotwired/stimulus'
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils'

export default class extends Controller {
  static targets = ['input', 'hidden']
  static values = {
    initialCountry: { type: String, default: 'fr' },
    preferredCountries: { type: Array, default: [] },
  }

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: this.initialCountryValue,
      separateDialCode: true,
      autoPlaceholder: 'polite',
      preferredCountries: this.preferredCountriesValue.length > 0 ?
        this.preferredCountriesValue :
        ['fr', 'be', 'ch', 'lu', 'de', 'es', 'gb', 'us'],
    })

    if (this.hasHiddenTarget && this.hiddenTarget.value) {
      this.iti.setNumber(this.hiddenTarget.value)
    }

    this.boundOnInput = () => this.syncHidden()
    this.boundOnCountryChange = () => this.syncHidden()
    this.inputTarget.addEventListener('input', this.boundOnInput)
    this.inputTarget.addEventListener('blur', this.boundOnInput)
    this.inputTarget.addEventListener('countrychange', this.boundOnCountryChange)
    this.syncHidden()
  }

  disconnect() {
    if (this.inputTarget) {
      this.inputTarget.removeEventListener('input', this.boundOnInput)
      this.inputTarget.removeEventListener('blur', this.boundOnInput)
      this.inputTarget.removeEventListener(
        'countrychange',
        this.boundOnCountryChange
      )
    }
    if (this.iti) {
      this.iti.destroy()
      this.iti = null
    }
  }

  syncHidden() {
    if (!this.hasHiddenTarget || !this.iti) return
    if (this.iti.isValidNumber()) {
      this.hiddenTarget.value = this.iti.getNumber()
    } else {
      this.hiddenTarget.value = ''
    }
  }
}
